import styled from '@emotion/styled';
import { RacemapColors } from '@racemap/utilities/consts/common';
import { getAddOnsOfEventType } from '@racemap/utilities/functions/events/getAddOnsOfEventType';
import { Flex, Spin, Typography } from 'antd';
import type { FC } from 'react';
import { useUser } from 'src/lib/customHooks';
import { useCurrentEvent } from 'src/lib/customHooks/useCurrentEvent';
import { usePriceList } from 'src/lib/customHooks/usePriceList';
import { AddOnCard } from './AddOnCard';

const { Title } = Typography;

export const AddOnCardsPanel: FC = () => {
  const event = useCurrentEvent();
  const { user } = useUser({ userId: event?.creatorId });
  const { isLoading } = usePriceList({ isReseller: user?.isReseller });
  const addons = getAddOnsOfEventType(event?.type);

  return (
    <div>
      <Title level={3}>Add-Ons</Title>
      <Container>
        <Spin spinning={isLoading}>
          <Flex vertical gap={12}>
            {Object.values(addons).map((addOnKey) => {
              return <AddOnCard key={addOnKey} addOnKey={addOnKey} />;
            })}
          </Flex>
        </Spin>
      </Container>
    </div>
  );
};

const Container = styled.div`
  border: solid 1px ${RacemapColors.LightGray};
  border-radius: 5px;
  padding: 30px ;
  width: 100%;
  background-color: white;
`;
